/**
 * Abruf der aktiven JTL-Warenlager - Grundlage der Lager-Auswahl in `lib/lager.ts`.
 *
 * `GET /api/jtl/warehouses` (`backend/src/http/routes/jtl.ts`) antwortet wie `/api/suppliers` und
 * `/api/articles` mit einem BLANKEN Array, kein benanntes Feld - anders als `/api/jtl/orders`
 * (`api/jtlBestellungen.ts`), das unter `{ bestellungen: [...] }` verschachtelt. Kein Cache, keine
 * Suche: die Liste ist klein (acht aktive Lager am 2026-08-19) und traegt keinen Suchbegriff, den
 * es zu debouncen gaebe - derselbe Grund, den die Route selbst dafuer nennt.
 */
import { anfrage } from "./basis.ts";
import type { JtlLager } from "../lib/lager.ts";

export const BASISPFAD = "/api/jtl/warehouses";

/** Laedt die aktiven JTL-Warenlager, in JTL-Reihenfolge (die Route sortiert bereits so). */
export function jtlLagerLaden(signal?: AbortSignal): Promise<JtlLager[]> {
  return anfrage<JtlLager[]>(BASISPFAD, { signal });
}
